import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormsyDate } from 'formsy-material-ui';
import FlatButton from 'material-ui/FlatButton';

const style = {
    required: {},
    optional: {
        display: "inline-block"
    },
    clearButton: {
    }
};

const formatDate = (date) => (date instanceof Date ? date.toLocaleDateString() : null);

class DatePicker extends Component {

    componentWillReceiveProps(props) {
        if (this.props.value !== props.value) {
            this.setValue(props.value);
        }
    }

    render() {
        // unpack certain elements from props:
        const {fullWidth, minDate, maxDate, ...props} = this.props;
        const floatingLabelText = `${props.floatingLabelText} ${props.required ? ' *' : ''}`;
        return (
            <div>
                <FormsyDate
                    ref="formsyDate"
                    style={props.required ? style.required : style.optional}
                    {...props}
                    floatingLabelText={floatingLabelText}
                    className="input-field datepicker"
                    fullWidth={props.required && fullWidth}
                    locale='en-GB'
                    minDate={minDate || undefined}
                    maxDate={maxDate || undefined}
                    formatDate={formatDate}
                />
                {!this.props.required && (
                    <FlatButton
                        style={style.clearButton}
                        label="X"
                        onTouchTap={() => this.handleValueChange() }
                    />
                )}
            </div>
        )
    }

    handleValueChange() {
        this.refs['formsyDate'].setValue(null);
    }

    setValue(value) {
        this.refs['formsyDate'].setValue(value);
    }

}

DatePicker.propTypes = {
    floatingLabelText:  PropTypes.string,
    required:           PropTypes.bool,
    fullWidth:          PropTypes.bool,
};

DatePicker.defaultProps = {
    required: false,
    fullWidth: true
};

export default DatePicker;
